import { GetCurrentUserOutput } from '@aws-amplify/auth';
import { create } from 'zustand';

interface Store {
  currentUser: GetCurrentUserOutput | null;
  setCurrentUser: (user: GetCurrentUserOutput | null) => void;
}

export const useCurrentUser = create<Store>((set) => {
  return {
    currentUser: null,
    setCurrentUser: (user: GetCurrentUserOutput) => set({ currentUser: user }),
  };
});

interface TableStore {
  searchValue: string;
  resetTableState: () => void;
  setSearchValue: (value: string) => void;
}

export const useTableStore = create<TableStore>((set) => {
  return {
    searchValue: '',
    setSearchValue: (value: string) => set({ searchValue: value }),
    resetTableState: () => set({ searchValue: '' }),
  };
});
